const initialState = {
  language: navigator.language
}

export default (state = initialState, { type, payload }) => {
  switch (type) {

  case 'changeLanguage':
    return { ...state, ...payload }

  default:
    return state
  }
}
